import { ReactNode } from "react";
import { Link } from "react-router";
import initPushNotifications from "utils/initPushNotifications";
import GridTile from "./GridTile";
import { useQuickActions } from "./useQuickActions";
import WidgetReportDocuments from "./WidgetReportDocuments";

const gridCols = ["grid-cols-1", "grid-cols-2", "grid-cols-3"];

const toRows = <T,>(arr: T[]): T[][] => {
  const rows: T[][] = [];

  for (let i = 0; i < arr.length; i += 3) {
    rows.push(arr.slice(i, i + 3));
  }

  return rows;
};

const QuickActions = () => {
  const [quickLinks, terminalLinks, externalLinks, bottomExternalLinks] = useQuickActions();

  return (
    <div className="flex flex-col gap-0.5 sm:gap-1">
      {toRows(quickLinks).map((row, i) => (
        <div
          key={i}
          className={`grid ${gridCols[row.length - 1]} gap-0.5 sm:gap-1`}
        >
          {row.map((action, j) => (
            <QuickLink
              key={j}
              {...action}
              initPushNotifications={initPushNotifications}
            />
          ))}
        </div>
      ))}
      {toRows(terminalLinks).map((row, i) => (
        <div
          key={i}
          className={`grid ${gridCols[row.length - 1]} gap-0.5 sm:gap-1`}
        >
          {row.map((action, j) => (
            <QuickLink
              key={j}
              {...action}
              initPushNotifications={initPushNotifications}
            />
          ))}
        </div>
      ))}
      {toRows(externalLinks).map((row, i) => (
        <div
          key={i}
          className={`grid ${gridCols[row.length - 1]} gap-0.5 sm:gap-1`}
        >
          {row.map((action, j) => (
            <QuickLink external key={j} {...action} />
          ))}
        </div>
      ))}
      <div className="grid grid-cols-2 gap-0.5 sm:gap-1">
        <WidgetReportDocuments />
        {bottomExternalLinks.map((action, i) => (
          <QuickLink external {...action} key={i} />
        ))}
      </div>
    </div>
  );
};

const QuickLink = ({
  external,
  link,
  initPushNotifications,
  ...props
}: {
  external?: boolean;
  icon: ReactNode;
  label: ReactNode;
  link: string;
  description?: string;
  initPushNotifications?: () => void;
}) => {
  return (
    <GridTile {...props}>
      {external ? (
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="absolute inset-0"
        />
      ) : (
        <Link
          to={link}
          className="absolute inset-0"
          onClick={() => {
            if (initPushNotifications) initPushNotifications();
          }}
        />
      )}
    </GridTile>
  );
};

export default QuickActions;
